import { API_VERSION_ESYMANDANT, fetchHandler, fileUploadRequestBuilder, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'
import { accessTokenForm } from 'application/storage/access_token'

export const postFilesAssistant = (files) => {
    const request = fileUploadRequestBuilder(API_VERSION_ESYMANDANT + '/files/upload', files, [], true, false, false, accessTokenForm)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}